import { UserEventLogPage } from './index'
import { AdminOverride } from './../../shared/router/overrides'
import { RouteFactory } from './../../shared/router/Route.factory'
import {
  RequiresAuthGuard,
  RequiresUsertypesGuard,
} from './../../shared/router/guards'

export default [
  RouteFactory.create(
    UserEventLogPage,
    '/accounts/history',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard([
        'agency-owner',
        'internal-admin',
        'system-admin',
      ]),
      AdminOverride,
    ],
    {
      name: 'User History',
    }
  ),
]
